(function () {

    let toggles = document.querySelectorAll('.view-toggle .styled-checkbox');
    let filterForm = document.querySelector('.part-category-filter');

    toggles.forEach(el => el.addEventListener('click', function (e) { toggleView(e) }));
        

    function toggleView(e) {
        console.log('view toggle: ', e.target);

        if (e.target.getAttribute('checked') != 'checked') {
            filterForm.submit();
		}
    }
})();